"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityTooLargeRule = void 0;
exports.isEntityTooLarge = isEntityTooLarge;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
const ruleId = 'entity-too-large';
const ruleName = 'entity too large';
const ruleDescription = 'entities with number of attributes exceeding the threshold';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.EntityId.array().optional(),
    max: zod_1.z.number()
}).strict().describe('EntityTooLargeConf');
exports.entityTooLargeRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.medium, max: 30 },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.entityRefFromId) || []);
        return (db.entities || [])
            .filter(e => isEntityTooLarge(e, conf.max))
            .filter(e => !ignores.some(i => (0, databaseUtils_1.entityRefSame)(i, (0, databaseUtils_1.entityToRef)(e))))
            .map(e => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Entity ${(0, databaseUtils_1.entityToId)(e)} has too many attributes (${e.attrs?.length || 0}).`,
            entity: (0, databaseUtils_1.entityToRef)(e),
            extra: { attributes: e.attrs?.length || 0 }
        }));
    }
};
// same as frontend/src/PagesComponents/Organization_/Project_/Views/Modals/SchemaAnalysis/TableTooBig.elm
function isEntityTooLarge(entity, max) {
    return (entity.attrs?.length || 0) > max;
}
//# sourceMappingURL=entityTooLarge.js.map